import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import Loader from '../components/Loader';
import { FaSave } from 'react-icons/fa';
import { MdDelete } from 'react-icons/md';
import { PiDotsThree } from 'react-icons/pi';
import { formatDateTime } from '../utils/formatDate';
import Pagination from '../components/Pagination';

const Claims = () => {
  const [claimData, setClaimData] = useState({
  });
  const [packages, setPackages] = useState([]);
  const [unprocessedPackages, setUnprocessedPackages] = useState([]);
  const  [currentPage, setCurrentPage] = useState(1);

  const [openModal, setOpenModal] = useState([]);
  const [modalData, setModalData] = useState(null); // Modal data for Add/Edit
  const [deleteId, setDeleteId] = useState(null); // ID for delete confirmation
  const [activeTab, setActiveTab] = useState('unapproved');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [metaData, setMetaData] = useState({
    totalItems: 0,
    totalPages: 0,
    currentPage: 1,
    pageSize: 10,
  });

  const apiUrl = process.env.REACT_APP_BASE_URL;
  const user = JSON.parse(localStorage.getItem('user'));


  const fetchPackages = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(user.role == "Courier" ? `${apiUrl}/api/claims/${user.courier_id}?page=${currentPage}` : `${apiUrl}/api/claims`);
      if (!response.ok) throw new Error('Failed to fetch packages');
      const data = await response.json();
      setUnprocessedPackages(data.packages.filter((pkg) => !pkg.approved));
      setPackages(data.packages.filter((pkg) => pkg.approved));
      setMetaData(data.meta || {});
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPackages();
  }, [currentPage]);

  const handleTabChange = (tab) => setActiveTab(tab);

  const handleSave = async (data) => {
    try {
      const method = data.id ? 'PUT' : 'POST';
      const url = data.id
        ? `${apiUrl}/api/packages/${data.id}`
        : `${apiUrl}/api/unknown-packages`;

      const response = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });
      if (!response.ok) throw new Error('Error saving package');
      await fetchPackages();
      setModalData(null);
    } catch (err) {
      setError('Error saving package. Please try again.');
    }
  };
  const handleApproval = async (id) =>{
    const toApprove = [...packages, ...unprocessedPackages].find((approve) => approve.id === id)
    if (toApprove) {
      const response = await fetch(`${apiUrl}/api/packages/approve/${toApprove.tracking_number}`, {
        method: 'PUT', 
        body: JSON.stringify({
        trackingNumber: toApprove.tracking_number,
        staff_id: user.id,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    });
    }
    fetchPackages();
  }

  const handleDelete = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/unknown-packages/${deleteId}`, {
        method: 'DELETE',
      });
      if (!response.ok) throw new Error('Error deleting package');
      await fetchPackages();
      setDeleteId(null);
    } catch (err) {
      setError('Error deleting package. Please try again.');
    }
  };

  const PackageTable = ({ packages, onApprove, onDelete }) => (
    <table className="table-auto w-full border-collapse border border-gray-300">
      <thead className="bg-gray-100">
        <tr>
          <th className="border px-2 sm:px-4 py-2">Package</th>
          <th className="border px-2 sm:px-4 py-2">Tracking Number</th>
          <th className="border px-2 sm:px-4 py-2">Account</th>
          <th className="border px-2 sm:px-4 py-2">Courier</th>
          <th className="border px-2 sm:px-4 py-2">Approved</th>
          <th className="border px-2 sm:px-4 py-2">Actions</th>
        </tr>
      </thead>
      <tbody>
        {packages.length > 0 ? (
          packages.map((pkg) => (
            <tr key={pkg.id} className="hover:bg-slate-200">
              <td className="border px-2">{pkg.package}</td>
              <td className="border px-2">{pkg.tracking_number}</td>
              <td className="border px-2">{pkg?.account != null  ? `${pkg?.account?.first_name} ${pkg?.account?.first_name}` : '----'}</td>
              <td className="border px-2">{pkg?.shipper?.username ?? ''}</td>
              <td className="border px-2">
                {pkg.approved ? formatDateTime(pkg.updated_at) : '--'}
              </td>
              {user.role == "Courier" ? "" : <td className="border px-2 flex gap-2">
                <button className="btn btn-sm btn-secondary" onClick={() => onApprove(pkg.id)}>
                  {pkg.approved ? 'Unapprove' : 'Approve'}
                </button>
                {/* <button className="btn btn-sm btn-danger" onClick={() => setDeleteId(pkg.id)}>
                  Delete
                </button> */}
              </td>}
              
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="6" className="text-center">
              No Packages Available
            </td>
          </tr>
        )}
      </tbody>
 
    </table>
  );

  return (
    <Layout>
      {loading ? (
        <Loader />
      ) : (
        <div className="p-4 bg-base-100 shadow-xl w-4/5 lg:w-full h-[100%]">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-3xl font-semibold">Claims</h2>
  
          </div>

          {error && <div className="alert alert-error">{error}</div>}

          <div className="tabs">
            <button
              className={`tab ${activeTab === 'unapproved' ? 'tab-active bg-primary' : ''}`}
              onClick={() => handleTabChange('unapproved')}
            >
              Unapproved
            </button>
            {user.role !== "Courier" ? <button
              className={`tab ${activeTab === 'approved' ? 'tab-active bg-primary' : ''}`}
              onClick={() => handleTabChange('approved')}
            >
              Approved
            </button> : null}
            
          </div>

          {activeTab === 'unapproved' && (
            <PackageTable
              packages={unprocessedPackages}
              onApprove={(id) => handleApproval(id)}
              onDelete={(id) => setDeleteId(id)}
            />
          )}
          {activeTab === 'approved' && user.role !== "Courier" && (
            <PackageTable
              packages={packages}
              onApprove={(id) => handleApproval(id)}
              onDelete={(id) => setDeleteId(id)}
            />
          )}
               <Pagination
          currentPage={metaData.currentPage}
          totalPages={metaData.totalPages}
          onPageChange={(page) => setCurrentPage(page)}
        />
        </div>
        
      )}

      {/* Add/Edit Modal */}
    

      {/* Delete Confirmation Modal */}
      {/* {deleteId && (
        <dialog className="modal modal-open">
          <div className="modal-box">
            <h3>Confirm Deletion</h3>
            <p>Are you sure you want to delete this package?</p>
            <div className="modal-action">
              <button className="btn" onClick={() => setDeleteId(null)}>
                Cancel
              </button>
              <button className="btn btn-danger" onClick={handleDelete}>
                Delete
              </button>
            </div>
          </div>
        </dialog>
      )} */}
    </Layout>
  );
};

export default Claims;


// {openModal && (
//   <dialog className="modal modal-open bg-gray-50">
//     <form
//       className="modal-box"
//       onSubmit={(e) => {
//         e.preventDefault();
//         handleSave(modalData);
//       }}
//     >
//       <h3 className="font-bold text-lg">{modalData.id ? 'Edit Package' : 'Add Package'}</h3>
//       <div className="form-control">
//         <label htmlFor="tracking_number">Tracking Number</label>
//         <input
//           type="text"
//           name="tracking_number"
//           value={modalData.tracking_number || ''}
//           onChange={(e) =>
//             setModalData((prev) => ({ ...prev, tracking_number: e.target.value }))
//           }
//           className="input input-bordered"
//           required
//         />
//       </div>
//       {/* Add other fields here */}
//       <div className="modal-action">
//         <button type="button" className="btn" onClick={() => setModalData(null)}>
//           Cancel
//         </button>
//         <button type="submit" className="btn btn-primary">
//           <FaSave />
//           Save
//         </button>
//       </div>
//     </form>
//   </dialog>
// )}